import { createEvent as u, createStore as d, createEffect as H, scopeBind as E, attach as P, sample as c, combine as A, is as K } from "effector";
function k(e, n) {
  try {
    const t = e();
    return t === void 0 ? n : t;
  } catch {
    return n;
  }
}
function y({
  add: e,
  remove: n,
  readPayload: t
}, r) {
  const a = u(), o = d(null, {
    serialize: "ignore"
  }), i = H(() => {
    const v = E(a, { safe: !0 });
    let h = v;
    return t && (h = () => v(t())), e(h), h;
  }), l = P({
    source: o,
    effect(v) {
      v && n(v);
    }
  });
  return c({ clock: r.setup, target: i }), c({
    clock: i.doneData,
    filter: Boolean,
    target: o
  }), r.teardown && c({ clock: r.teardown, target: l }), c({ clock: l.done, target: o.reinit }), a;
}
function B(e) {
  return e.map((n) => n);
}
const T = (e) => {
  const n = d(
    k(() => screen.orientation.type, null),
    {
      serialize: "ignore"
    }
  ), t = d(
    k(() => screen.orientation.angle, null),
    { serialize: "ignore" }
  ), r = n.map((i) => i === "landscape-primary" || i === "landscape-secondary"), a = n.map((i) => i === "portrait-primary" || i === "portrait-secondary"), o = y(
    {
      add: (i) => screen.orientation.addEventListener("change", i),
      remove: (i) => screen.orientation.removeEventListener("change", i),
      readPayload: () => screen.orientation
    },
    e
  );
  return c({
    clock: o,
    fn: () => screen.orientation.type,
    target: n
  }), c({
    clock: o,
    fn: () => screen.orientation.angle,
    target: t
  }), { $type: n, $angle: t, $portrait: a, $landscape: r };
};
T["@@trigger"] = () => {
  const e = u(), n = u(), { $type: t } = T({ setup: e, teardown: n }), r = c({
    clock: t.updates,
    fn: () => {
    }
  });
  return { setup: e, teardown: n, fired: r };
};
const V = (e) => {
  const n = y(
    {
      add: (l) => document.addEventListener("visibilitychange", l),
      remove: (l) => document.removeEventListener("visibilitychange", l),
      readPayload: () => document.visibilityState
    },
    e
  ), t = d(
    k(() => document.visibilityState, "visible"),
    { serialize: "ignore" }
  ).on(n, (l, v) => v), r = t.map((l) => l === "visible"), a = t.map((l) => l === "hidden"), o = c({
    clock: r.updates,
    filter: Boolean,
    fn: () => {
    }
  }), i = c({
    clock: a.updates,
    filter: Boolean,
    fn: () => {
    }
  });
  return { visible: o, hidden: i, $visible: r, $hidden: a };
};
V["@@trigger"] = () => {
  const e = u(), n = u(), { visible: t } = V({ setup: e, teardown: n });
  return { setup: e, teardown: n, fired: t };
};
const _ = (e) => {
  const n = y(
    {
      add: (o) => window.addEventListener("online", o),
      remove: (o) => window.removeEventListener("online", o)
    },
    e
  ), t = y(
    {
      add: (o) => window.addEventListener("offline", o),
      remove: (o) => window.removeEventListener("offline", o)
    },
    e
  ), r = d(
    k(() => navigator.onLine, !0),
    { serialize: "ignore" }
  ).on(n, () => !0).on(t, () => !1), a = r.map((o) => !o);
  return { online: n, offline: t, $offline: a, $online: r };
};
_["@@trigger"] = () => {
  const e = u(), n = u(), { online: t } = _({ setup: e, teardown: n });
  return { setup: e, teardown: n, fired: t };
};
function G(e, n) {
  if (typeof e == "string") {
    if (n)
      return x(e, n);
    {
      const t = (r) => x(e, r);
      return t["@@trigger"] = () => {
        const r = u(), a = u(), { matched: o } = x(e, { setup: r, teardown: a });
        return { setup: r, teardown: a, fired: o };
      }, t;
    }
  } else if (n) {
    const t = {};
    for (const [r, a] of Object.entries(e))
      t[r] = G(a, n);
    return t;
  } else {
    const t = {};
    for (const [r, a] of Object.entries(e))
      t[r] = (o) => G(a, o);
    return t;
  }
}
function x(e, n) {
  const t = k(() => window.matchMedia(e), null), r = y(
    {
      add: (i) => t == null ? void 0 : t.addEventListener("change", i),
      remove: (i) => t == null ? void 0 : t.removeEventListener("change", i)
    },
    n
  ), a = d((t == null ? void 0 : t.matches) ?? !1, {
    serialize: "ignore"
  }).on(r, (i, l) => l.matches), o = u();
  return c({
    clock: [a.updates, n.setup],
    filter: a,
    fn: () => {
    },
    target: o
  }), { $matches: a, matched: o };
}
const U = d(null, {
  serialize: "ignore"
}), Q = U.map((e) => e ? e.split(",").map((n) => {
  var t;
  return (t = n.split(";")[0]) == null ? void 0 : t.trim();
}).filter((n) => n && n !== "*") : []), D = (e) => {
  const n = d(
    k(() => navigator.languages, []),
    { serialize: "ignore" }
  ), t = y(
    {
      add: (i) => window.addEventListener("languagechange", i),
      remove: (i) => window.removeEventListener("languagechange", i),
      readPayload: () => navigator.languages
    },
    e
  );
  c({ clock: t, target: n });
  const r = A(
    { fromHeader: Q, fromNavigator: n },
    ({ fromHeader: i, fromNavigator: l }) => i.length > 0 ? i : l
  ), a = r.map(
    (i) => i[0] ?? null
  ), o = c({
    clock: t,
    fn() {
    }
  });
  return { $languages: r, $language: a, languageChanged: o };
};
D["@@trigger"] = () => {
  const e = u(), n = u(), { languageChanged: t } = D({ setup: e, teardown: n });
  return { setup: e, teardown: n, fired: t };
};
D.$acceptLanguageHeader = U;
const W = Symbol("BrowserProvider");
function J(e) {
  let n;
  const t = e == null ? void 0 : e.providers;
  K.store(t) ? n = t : n = d(t ?? [W]);
  const r = P({
    source: n,
    effect(s) {
      return s.map((f) => R(f, e)).filter(Boolean);
    }
  }), a = d(
    null,
    { serialize: "ignore" }
  ).on(r.doneData, (s, f) => f), o = d(null), i = A(
    o,
    (s) => (s == null ? void 0 : s.longitude) ?? null
  ), l = A(
    o,
    (s) => (s == null ? void 0 : s.latitude) ?? null
  ), v = u(), h = u(), z = u(), O = d(!1), L = u(), S = u();
  c({
    clock: S,
    fn: (s) => ({ latitude: s.coords.latitude, longitude: s.coords.longitude }),
    target: o
  });
  const C = P({
    source: a,
    async effect(s) {
      let f = null;
      const $ = E(L, { safe: !0 });
      let w;
      s ? w = s : w = await r();
      for (const p of w)
        try {
          N(p) ? f = await new Promise(
            (m, g) => p.getCurrentPosition(m, g, e)
          ) : f = await p.getCurrentPosition();
        } catch (m) {
          $(m);
        }
      if (!f)
        throw {
          code: "POSITION_UNAVAILABLE",
          message: "No available geolocation provider"
        };
      return f;
    }
  });
  c({ clock: v, target: C }), c({
    clock: C.doneData,
    target: S
  }), c({ clock: C.failData, target: L });
  const F = d(null), I = P({
    source: a,
    async effect(s) {
      const f = E(S, { safe: !0 }), $ = E(L, { safe: !0 });
      let w;
      s ? w = s : w = await r();
      const p = /* @__PURE__ */ new Map(), m = /* @__PURE__ */ new Set();
      for (const g of w)
        try {
          if (N(g)) {
            const b = g.watchPosition(
              f,
              $,
              e
            );
            p.set(
              (j) => g.clearWatch(j),
              b
            );
          } else {
            const b = g.watchPosition(
              f,
              $
            );
            m.add(b);
          }
        } catch (b) {
          $(b);
        }
      return () => {
        for (const [g, b] of p)
          g(b), p.delete(g);
        for (const g of m)
          g(), m.delete(g);
      };
    }
  }), M = P({
    source: F,
    effect(s) {
      s == null || s();
    }
  });
  return c({ clock: h, target: I }), c({ clock: I.doneData, target: F }), c({ clock: z, target: M }), c({ clock: M.finally, target: F.reinit }), O.on(h, () => !0).on(z, () => !1), {
    $location: B(o),
    $longitude: i,
    $latitude: l,
    request: v,
    watching: {
      start: h,
      stop: z,
      $active: B(O)
    },
    reporting: {
      failed: B(L)
    }
  };
}
J.browserProvider = W;
function R(e, n) {
  return e === W ? globalThis.navigator && "geolocation" in globalThis.navigator ? globalThis.navigator.geolocation : null : N(e) ? e : e(n ?? {});
}
function N(e) {
  return "getCurrentPosition" in e && "watchPosition" in e && "clearWatch" in e;
}
export {
  J as trackGeolocation,
  G as trackMediaQuery,
  _ as trackNetworkStatus,
  V as trackPageVisibility,
  D as trackPreferredLanguages,
  T as trackScreenOrientation
};
